import { useEffect, useState } from 'react';
import { Tabs, Space, Input, Badge } from 'antd';
import Table from '../../TableResizable';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined, ContactsOutlined, BarChartOutlined } from '@ant-design/icons';
import axios from 'axios';
import Tab1 from './Tab1';
import Utilisateur from '../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import Data from '../../../Data/Data.json';
import SweetAlert from "sweetalert2";
import { Crypter } from '../../../Functions/Security/Crypter';
import { Box, Typography } from '@mui/material';
import Tab2 from './Tab2';
import { ColumnsType } from 'antd/es/table';
import InputForm from '../../InputT';
import DataCpt from '../../../Types/DataCpt';
import ParamsPicklist from '../../../Types/ParamsPicklist';
import SearchInput from '../../SearchInput';
import Tab3 from './Tab3';
import DataProcurationClient from '../../../Types/DataProcurationClient';
import DataRelationClient from '../../../Types/DataRelationClient';
import DataHistoCpt from '../../../Types/DataHistoCpt';
import { HistoCpt } from '../../../Models/HistoCpt';
import { useNavigate } from 'react-router-dom';
import formatNumber from '../../../Functions/Traitement/FormatNumber';
import Tab4 from './Tab4';
import Tab7 from './Tab7';
import DataPeriodAuto from "../../../Functions/Traitement/DataPeriodAuto";
import DataType from '../../../Functions/Traitement/DataPeriodMbloquer';
import DataPeriodMVirement from "../../../Functions/Traitement/DataPeriodMVirement";
import { useParams } from 'react-router-dom';
import Pret from '../../../Models/Pret';
import Tab5 from './Tab5';
import Tab6 from './Tab6';
import Tab8 from './Tab8';
import Tab9 from './Tab9';
import { PrintHistCompteDirect } from '../../../utilitaires/globalFunction';
import { printFicheClient } from './exportFicheClient';
import Agence from '../../../Models/Agence';
import { useAgence } from '../../../AgenceContext';
import tab1 from '../BlocageComptes/AddBlocage/ta1';

let searchClient: ParamsPicklist = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colagence: '', Colonne2: "NOMCLI", Choix: 22 }

const SituationCLient = () => {

  // USER SESSION
  const auth = useAuthUser();
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()));
  const Branch=useAgence()
   //const AuthBranch = BranchAuthUser();
   //const Branch: Agence = JSON.parse(JSON.stringify(auth()));
  // USER TOKEN
  const authHeader = useAuthHeader();
  const param = useParams();

  //input de reacherche
  const { Search } = Input;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [ActiveForm, SetActiveForm] = useState(false);
  const [DataCpt, setDataCpt] = useState<DataCpt[]>([]);
  const [DataHisto, setDataHisto] = useState<DataHistoCpt[]>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [index, Setindex] = useState<number>(-1);
  const [SearchR, SetSearchR] = useState<string>("");
  const [DataSingCpt, SetDataSingCpt] = useState<DataRelationClient[]>([]);
  const [DataProCpt, SetDataProCpt] = useState<DataProcurationClient[]>([]);
  const [Imprimer, SetImprimer] = useState(true);
  const [Consulter, SetConsulter] = useState(false);
  const [Numcpt, SetNumcpt] = useState<string>("");
  const [DataMontantBloque, SetDataMontantBloque] = useState<DataType[]>([]);
  const [start, setstart] = useState<boolean>(false);
  const [DataPeriodAuto, setDataPeriodAuto] = useState<DataPeriodAuto[]>([]);
  const [DataPeriodMVirement, setDataPeriodMVirement] = useState<DataPeriodMVirement[]>([]);
  const [dataFinQard,       setDataFinQard]       = useState<any[]>([]);
  const [dataFinSalam,      setDataFinSalam]       = useState<any[]>([]);
  const [dataFinMourabaha,  setDataFinMourabaha]   = useState<any[]>([]);
  const [dataFinIjara,      setDataFinIjara]       = useState<any[]>([]);
  const [dataStats,         setDataStats]          = useState<any>(null);

  const navigate = useNavigate();

  useEffect(() => {
    if (start == false) {
      HandlerChange();
      setstart(true);
    }
    else {

    }
  }, []);


  const HandlerChange = async () => {
    setLoading(true);
    if (param.id && param.id !== '0') form.setFieldValue("NUMCLI", param.id);

    await loadCompteClient();
    setLoading(false)
  }


  function initialiazeButton() {
    SetImprimer(true);
    SetConsulter(true);

  }

  const column: ColumnsType<DataHistoCpt> = [
    {
      title: 'Date Opération ',
      dataIndex: 'DATOPE',
      align: 'left'
    },
    {
      title: 'Heure',
      dataIndex: 'TIME',
      align: 'left'
    },
    {
      title: 'Date Valeur',
      dataIndex: 'DEDEVR',
      align: 'left'
    },
    {
      title: 'Reference',
      dataIndex: 'REPECE',
      align: 'left'
    },
    {
      title: 'Libelle',
      dataIndex: 'LIBELL',
      align: 'left'
    },
    {
      title: 'Montant Débit',
      dataIndex: 'MONTANTDEBIT',
      align: 'left'
    },
    {
      title: 'Montant Crédit',
      dataIndex: 'MONTANTCREDIT',
      align: 'left'

    },
    {
      title: 'Solde Total',
      dataIndex: 'SOLDT',
      align: 'left'
    },
    {
      title: 'Beneficiare',
      dataIndex: 'NBENEF',
      align: 'left'
    }
    ,
    {
      title: 'Utilisateur Saiair',
      dataIndex: 'UTISAI',
      align: 'left'
    }
  ];

  const columns: ColumnsType<DataCpt> = [
    {
      title: 'Agence',
      dataIndex: 'AGCCPT',
      align: 'center',
      width: 70,
    },
    {
      title: 'N° Compte',
      dataIndex: 'NUMCPT',
      ellipsis: true,
      width: 200,
      filteredValue: [SearchR],
      onFilter: (value: any, record: any) => {
        return String(record.NUMCPT)
          .toLowerCase()
          .includes(value.toLowerCase()) ||
          String(record.NOMCPT)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.DATCRE)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.AGCCPT)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.SoldeV)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.Solde)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.DATCRE)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.DatMaj)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.Etat)
            .toLowerCase()
            .includes(value.toLowerCase())
      }
    },
    {
      title: 'Nom Compte',
      dataIndex: 'NOMCPT',
      ellipsis: true,
      width: 150,
    },
    {
      title: 'Plan Comptable',
      dataIndex: 'TYCPT',
    },
    {
      title: 'Solde  Veille',
      dataIndex: 'SoldeV',
      align:"right"
    },
    {
      title: 'Disponible ',
      dataIndex: 'Solde',
      align:"right"
    },
    {
      title: 'Date Creation',
      dataIndex: 'DATCRE',
    },
    {
      title: 'Date MAJ',
      dataIndex: 'DatMaj',
    },
    {
      title: 'Status',
      dataIndex: 'Etat',
      align: 'center',
      render: (text: any, record: any) => (
        <span>
          <Badge status='success' color={record.Etat == "01" ? 'green' : record.Etat == "11" ? 'red' : 'orange'} size='default' count={record.Etat == "01" ? 'Actif' : record.Etat == "11" ? 'Dormant' : 'Inatif'}> </Badge>
        </span>)
    },
    {
      title: "",
      dataIndex: 'RelObject',
      width: 1
    }
  ];


  const consult = async (Numcpt: string) => {

    SetDataProCpt([]);
    SetDataSingCpt([]);
    SetDataMontantBloque([]);
    setDataPeriodMVirement([]);

    let NUMCPT = Crypter.encrypt(Numcpt);
    let Agence = Crypter.encrypt(user.codage);
    setLoading(true);



    if (Numcpt.length !== 0) {

      //configuration pour les informations du compte
      let config1 = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetCompte,
        headers: {
          'CypherNumCpte': NUMCPT,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };

      //configuration pour avoir les signataires d'un compte

      let config2 = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetSignCpt,
        headers: {
          'CypherNumCpte': NUMCPT,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };

      //configuration pour avoir les procuration d'un compte

      let config3 = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetProCpt,
        headers: {
          'CypherNumCpte': NUMCPT,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };

      //configuration pour avoir Montant bloqué sur un compte compte
      let config4 = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.AllReadMontantBloquer,
        headers: {
          'Cyphercodage': Agence,
          'Cyphertrie': NUMCPT,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };

      //configuration pour avoir les ordres permanents d'un compte
      let config7 = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetDetailClient,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authHeader(),
          'CypherNumcli': Crypter.encrypt(Numcpt),
          'CypherCodu': Crypter.encrypt(user.coduti),
          'CypherAgence': Crypter.encrypt(user.codage),
          'CypherOption': Crypter.encrypt('3')
        },
      };

      let requestOne = axios.request(config1);
      let requestTwo = axios.request(config2);
      let requestTree = axios.request(config3);
      let requestFour = axios.request(config4);
      let requestSeven = axios.request(config7);



      await axios
        .all([requestOne, requestTwo, requestTree, requestFour, requestSeven])
        .then(
          await axios.spread(async (...responses: any) => {
            const responseOne = responses[0];
            const responseTwo = responses[1];
            const responseTree = responses[2];
            const responseFour = responses[3];
            const responseSeven = responses[4];

            if (responseOne.data) {
              localStorage.clear();
              const res = JSON.parse(Crypter.decrypt(responseOne.data));


              if (res.StatutCode === 200) {

                let datas = res.Result.Table[0];
                if (res.Result.Table.length > 0) {

                  form.setFieldsValue(res.Result.Table[0]);
                  form.setFieldValue('DISPON', formatNumber(res.Result.Table[0].DISPON));

                  SetConsulter(false);
                  SetActiveForm(false);
                  //  setLoading(false);

                  form.setFieldValue('lib_NUMCPT', datas.NOMCPT);
                  let datat: DataRelationClient[] = [];
                  // let dataA: DataType[] = [];
                  let dataP: DataProcurationClient[] = [];
                  // form.setFieldValue('categocpt', datas.categocpt + '-' + datas.lib_categocpt);
                  if (responseTwo.data) {

                    const res = JSON.parse(Crypter.decrypt(responseTwo.data));

                    if (res.StatutCode === 200) {
                      if (res.Result.Table.length > 0) {
                        if (typeof res.Result.Table != 'undefined' || "") {
                          res.Result.Table.map((data: any, indice: any) => {
                            datat.push({
                              key: indice,
                              NUMCPT: data.NUMCPT,
                              idclient: data.IdClient,
                              CODEREL: data.CODREL,
                              Nom: data.NomRel,
                              Prenom: data.Prenom,
                              Tel: data.TelRel,
                              filiation: data.lib_filiation,
                              Datecre: data.DatCre ? (new Date(data.DatCre.substring(0, 10))).toLocaleDateString("fr") : '',
                              INSTITULER: data.INSTITULER,
                              RelObject: data,
                              Plafond: data.LIMITE
                            })
                          });
                        }
                      }
                    }
                  }

                  if (datat.length > 0) { SetDataSingCpt(datat); }
                  if (responseTree.data) {
                    const res = JSON.parse(Crypter.decrypt(responseTree.data));
                    if (res.StatutCode === 200) {
                      let datas = res.Result.Table;
                      if (res.Result.Table.length > 0) {

                        if (typeof res.Result.Table != 'undefined' || "") {
                          // alert(JSON.stringify(datat));
                          datas.map((data: any, indice: any) => {
                            dataP.push({
                              key: indice,
                              NUMCPT: data.NUMCPT,
                              idclient: data.idrel,
                              CODEREL: data.Refprocur,
                              Nom: data.nom,
                              Prenom: data.prenom,
                              Tel: data.TelProcur,
                              ville: data.lieuNais,
                              DateDebut: data.datDebut ? (new Date(data.datDebut.substring(0, 10))).toLocaleDateString("fr") : '',
                              DateFin: data.DatFin ? (new Date(data.DatFin.substring(0, 10))).toLocaleDateString("fr") : '',
                              plafond: data.LIMITE + "  " + "FCFA",
                              filiation: data.filiation + "-" + data.lib_filiation,
                              Datecre: data.datcre ? (new Date(data.datcre.substring(0, 10))).toLocaleDateString("fr") : '',
                              RelObject: data
                            })
                          });
                        }
                        if (dataP.length > 0) { SetDataProCpt(dataP) }

                      }
                    }
                  }
                  else {
                    setLoading(false);
                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                  }
                }
              }
              //si y'a la reponse pour le montant bloqué
              //MAPPING DANS LE TABLEAU 

              if (responseFour.data) {
                const res = responseFour.data;
                let datas = responseFour.data.Result;
                let dat: DataType[] = [];

                if (res.StatutCode === 200)
                {
                  if(datas.length>0){
                    datas.map((val: any, key: any) => {
                      dat.push({
                        key: key,
                        REFMARQ: val.REFMARQ,
                        codage: val.codage,
                        NUMCPT: val.NUMCPT,
                        NOMCPT: val.NOMCPT,
                        MONTPR: val.MONTPR,
                        DISPON: val.DISPON,
                        DATCRE: val.DATCRE ? (new Date(val.DATCRE.substring(0, 10))).toLocaleDateString("fr") : '',
                        DATEFM: val.DATEFM ? (new Date(val.DATEFM.substring(0, 10))).toLocaleDateString("fr") : '',
                        MOTIFM: val.MOTIFM,
                      })
                    })
                  }

                }
                if (dat.length > 0) { SetDataMontantBloque((dat)) }
              }

              if (responseSeven.data) {
                let dat: DataPeriodMVirement[] = [];
                const res = JSON.parse(Crypter.decrypt(responseSeven.data)).Value;
                if (res.StatutCode === 200) {
                  res.Result.map((val: any, key: any) => {
                    dat.push({
                      key: key,
                      NUMDOS: val.NUMDOS,
                      CODOPE: val.CODOPE,
                      DATSAI: val.DATSAI,
                      DATIMP: val.DATIMP,
                      CPTDEB: val.CPTDEB,
                      LIBCPTDEB: val.LIBCPTDEB,
                      CPTCRE: val.CPTCRE,
                      LIBCPTCRE: val.LIBCPTCRE,
                      MONTAN: val.MONTAN,
                      FREQIMP: val.FREQIMP,
                      NBRIMP: val.NBRIMP,
                      DECOUV: val.DECOUV,
                      DATARRIMP: val.DATARRIMP,
                      UTISAI: val.UTISAI,
                      UTIMOD: val.UTIMOD,
                      DATMOD: val.DATMOD,
                      IsFRAIS: val.IsFRAIS,
                      MONTAN1: val.MONTAN1,
                      MONTAN2: val.MONTAN2,
                      MONTAN3: val.MONTAN3,
                      MONTAN4: val.MONTAN4,
                      LIBELL1: val.LIBELL1,
                      LIBELL2: val.LIBELL2,
                      LIBELL3: val.LIBELL3,
                      LIBELL4: val.LIBELL4,
                      CODOP1: val.CODOP1,
                      CODOP2: val.CODOP2,
                      CODOP3: val.CODOP3,
                      CODOP4: val.CODOP4,
                      codage: val.codage,
                      cdetat: val.cdetat,
                      utival: val.utival,
                      isbloqAuto: val.isbloqAuto,
                      datval: val.datval
                    })
                  })
                  if (dat.length > 0) { setDataPeriodMVirement(dat) }
                }
              }
            }
          })).catch((error) => {
            setLoading(false);
            SweetAlert.fire({ title: "warning", text: error.message, icon: "error" });
          });
      setLoading(false);
    }
    else {
      setLoading(false);
      SweetAlert.fire({ title: "Warning", text: "Account not found", icon: "error" });
    }
  }


  //Données liées au CLIENT (indépendantes du compte sélectionné) :
  //financements, autorisations et statistiques — chargées dès le choix du client.
  const loadDetailClient = async () => {

    setDataPeriodAuto([]);
    setDataFinQard([]);
    setDataFinSalam([]);
    setDataFinMourabaha([]);
    setDataFinIjara([]);
    setDataStats(null);

    let Numcli = form.getFieldValue('NUMCLI');
    if (!Numcli) return;

    setLoading(true);

    //configuration pour avoir les financements d'un client
    let config1 = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.GetDetailClient,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherNumcli': Crypter.encrypt(Numcli),
        'CypherCodu': Crypter.encrypt(user.coduti),
        'CypherAgence': Crypter.encrypt(user.codage),
        'CypherOption': Crypter.encrypt('1')
      },
    };

    //configuration pour avoir les autorisations (facilités / découverts) d'un client
    let config2 = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.GetDetailClient,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherNumcli': Crypter.encrypt(Numcli),
        'CypherCodu': Crypter.encrypt(user.coduti),
        'CypherAgence': Crypter.encrypt(user.codage),
        'CypherOption': Crypter.encrypt('2')
      },
    };

    //configuration pour avoir les statistiques globales du client
    let config3 = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.GetDetailClient,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherNumcli': Crypter.encrypt(Numcli),
        'CypherCodu': Crypter.encrypt(user.coduti),
        'CypherAgence': Crypter.encrypt(user.codage),
        'CypherOption': Crypter.encrypt('5')
      },
    };

    let requestFin  = axios.request(config1);
    let requestAuto = axios.request(config2);
    let requestStat = axios.request(config3);

    await axios
      .all([requestFin, requestAuto, requestStat])
      .then(
        await axios.spread(async (...responses: any) => {
          const responseFin  = responses[0];
          const responseAuto = responses[1];
          const responseStat = responses[2];

          if (responseFin.data) {
            const res = JSON.parse(Crypter.decrypt(responseFin.data)).Value;
            if (res.StatutCode === 200) {
              //   Table1 → Qard / Table2 → Salam / Table3 → Mourabaha / Table4 → Ijara
              const tableQard      = res.Result?.Table1 ?? (Array.isArray(res.Result) ? res.Result : []);
              const tableSalam     = res.Result?.Table2 ?? [];
              const tableMourabaha = res.Result?.Table3 ?? [];
              const tableIjara     = res.Result?.Table4 ?? [];

              if (Array.isArray(tableQard) && tableQard.length > 0) {
                const datat = tableQard.map((data: any, indice: number) => ({
                  key: indice,
                  NumeroFinancement: data.NumeroFinancement,
                  CodeQard: data.CodeQard,
                  CODGEA: data.CODGEA,
                  NomGestionnaire: data.NomGestionnaire,
                  NomProduit: data.NomProduit,
                  MontantValide: formatNumber(data.MontantValide),
                  Numcli: data.Numcli ?? data.NumClient ?? data.NUMCLI ?? '',
                  Nomcli: data.Nomcli ?? data.NomClient ?? data.NOMCLI ?? '',
                  TotalDecaisse: formatNumber(data.TotalDecaisse),
                  ResteADecaisser: formatNumber(data.ResteADecaisser),
                  DateDemande: data.DateDemande ? (new Date(data.DateDemande.substring(0, 10))).toLocaleDateString("fr") : '',
                  DateVal: data.DateVal ? (new Date(data.DateVal.substring(0, 10))).toLocaleDateString("fr") : '',
                }));
                setDataFinQard(datat);
              } else {
                setDataFinQard([]);
              }

              if (Array.isArray(tableSalam) && tableSalam.length > 0) {
                const datatSalam = tableSalam.map((data: any, indice: number) => ({
                  key: indice,
                  NumeroFinancement: data.NumeroFinancement,
                  CodeSalam: data.CodeSalam,
                  CODGEA: data.CODGEA,
                  NomGestionnaire: data.NomGestionnaire,
                  NomProduit: data.NomProduit,
                  MontantValide: formatNumber(data.MontantValide ?? data.PrixVenteValide),
                  Numcli: data.Numcli ?? data.NumClient ?? data.NUMCLI ?? '',
                  Nomcli: data.Nomcli ?? data.NomClient ?? data.NOMCLI ?? '',
                  DateDemande: data.DateDemande ? (new Date(data.DateDemande.substring(0, 10))).toLocaleDateString("fr") : '',
                  DateVal: data.DateVal ? (new Date(data.DateVal.substring(0, 10))).toLocaleDateString("fr") : '',
                  DateLivraisonPrevue: data.DateLivraisonPrevue ?? data.DATELIVRAISONPREVUE ?? null,
                  StatutLivraison: data.statut ?? data.Statut ?? data.STATUT ?? '',
                }));
                setDataFinSalam(datatSalam);
              } else {
                setDataFinSalam([]);
              }

              if (Array.isArray(tableMourabaha) && tableMourabaha.length > 0) {
                const datatMourabaha = tableMourabaha.map((data: any, indice: number) => ({
                  key: indice,
                  NumeroFinancement: data.NumeroFinancement,
                  CodeMourabaha: data.CodeMourabaha,
                  CODGEA: data.CODGEA,
                  NomGestionnaire: data.NomGestionnaire,
                  NomProduit: data.NomProduit,
                  MontantValide: formatNumber(data.PrixVenteValide ?? data.MontantValide),
                  Numcli: data.Numcli ?? data.NumClient ?? data.NUMCLI ?? '',
                  Nomcli: data.Nomcli ?? data.NomClient ?? data.NOMCLI ?? '',
                  DateDemande: data.DateDemande ? (new Date(data.DateDemande.substring(0, 10))).toLocaleDateString("fr") : '',
                  DateVal: data.DateVal ? (new Date(data.DateVal.substring(0, 10))).toLocaleDateString("fr") : '',
                }));
                setDataFinMourabaha(datatMourabaha);
              } else {
                setDataFinMourabaha([]);
              }

              if (Array.isArray(tableIjara) && tableIjara.length > 0) {
                const datatIjara = tableIjara.map((data: any, indice: number) => ({
                  key: indice,
                  NumeroFinancement: data.NumeroFinancement,
                  CodeIjara: data.CodeIjara,
                  CODGEA: data.CODGEA,
                  NomGestionnaire: data.NomGestionnaire,
                  NomProduit: data.NomProduit,
                  MontantValide: formatNumber(data.MontantValide),
                  Numcli: data.Numcli ?? data.NumClient ?? data.NUMCLI ?? '',
                  Nomcli: data.Nomcli ?? data.NomClient ?? data.NOMCLI ?? '',
                  DateDemande: data.DateDemande ? (new Date(data.DateDemande.substring(0, 10))).toLocaleDateString("fr") : '',
                  DateVal: data.DateVal ? (new Date(data.DateVal.substring(0, 10))).toLocaleDateString("fr") : '',
                }));
                setDataFinIjara(datatIjara);
              } else {
                setDataFinIjara([]);
              }
            }
          }

          if (responseAuto.data) {
            let dat: DataPeriodAuto[] = [];
            const res = JSON.parse(Crypter.decrypt(responseAuto.data)).Value;
            if (res.StatutCode === 200) {
              res.Result.map((val: any, key: any) => {
                dat.push({
                  key: key,
                  NUMCRD: val.NUMCRD,
                  NUMCLI: val.NUMCLI,
                  NOMCLI: val.NOMCLI,
                  SERVGE: val.SERVGE,
                  NATCRD: val.NATCRD,
                  CDETAT: val.CDETAT,
                  MNTAUT: formatNumber(val.MNTAUT),
                  DATEFF: val.DATEFF ? (new Date(val.DATEFF.substring(0, 10))).toLocaleDateString("fr") : '',
                  DATEFIN: val.DATEFIN ? (new Date(val.DATEFIN.substring(0, 10))).toLocaleDateString("fr") : '',
                  CPTAUT: val.CPTAUT
                })
              })
              if (dat.length > 0) { setDataPeriodAuto(dat) }
            }
          }

          if (responseStat.data) {
            const res = JSON.parse(Crypter.decrypt(responseStat.data)).Value;
            if (res.StatutCode === 200 && res.Result) {
              setDataStats({
                kpi: res.Result.Table1 ?? [],
                repartition: res.Result.Table2 ?? [],
                statuts: res.Result.Table3 ?? [],
                remboursement: res.Result.Table4 ?? [],
                activiteMensuelle: res.Result.Table5 ?? [],
                evolutionSolde: res.Result.Table6 ?? [],
                topOperations: res.Result.Table7 ?? [],
                soldesComptes: res.Result.Table8 ?? [],
                soldesPlans: res.Result.Table9 ?? [],
                evolutionParCompte: res.Result.Table10 ?? [],
                mensuelParCompte: res.Result.Table11 ?? [],
                safeCareSouscriptions: res.Result.Table12 ?? [],
                demandesAssistance: res.Result.Table13 ?? [],
                demandesSouscription: res.Result.Table14 ?? [],
                bonsCaisse: res.Result.Table15 ?? [],
                demandesInterruptionBdc: res.Result.Table16 ?? [],
              });
            } else {
              setDataStats(null);
            }
          }
        })).catch((error) => {
          setLoading(false);
          SweetAlert.fire({ title: "warning", text: error.message, icon: "error" });
        });
    setLoading(false);
  }


  const onSelectChange = async (newSelectedRowKeys: any) => {

    let TOTALSV = form.getFieldValue('TOTALSV');
    let TOTALD = form.getFieldValue('TOTALD');
    let NUMCLI = form.getFieldValue('NUMCLI');
    let libNumcli = form.getFieldValue('lib_NUMCLI');

    form.resetFields();
    setDataHisto([]);
    setLoading(true);


    form.setFieldValue('TOTALSV', TOTALSV);
    form.setFieldValue('TOTALD', TOTALD);
    form.setFieldValue('NUMCLI', NUMCLI);
    if (libNumcli) form.setFieldValue('lib_NUMCLI', libNumcli);
    let DateD = user.datjour.substring(0, 4) + '-01-01';
    form.setFieldValue("datD", DateD);
    form.setFieldValue("DatF", user.datjour);

    SetNumcpt(DataCpt[newSelectedRowKeys].NUMCPT);
    setSelectedRowKeys(newSelectedRowKeys);
    Setindex(newSelectedRowKeys);
    //alert(DataCpt[newSelectedRowKeys].NUMCPT)
    await consult(DataCpt[newSelectedRowKeys].NUMCPT);
    setLoading(false)
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const loadCompteClient = async () => {
    setLoading(true);


    let numcli = form.getFieldValue("NUMCLI");

    setDataCpt([]);
    setSelectedRowKeys([]);
    SetNumcpt("");

    if (numcli != "") {
      let searchClientComptes: ParamsPicklist = { CodeAgence: '', Table: "COMPTES", Colonne1: "NUMCLI", Colonne2: "", Init: numcli, Colagence: '', Choix: 35 }
      var config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.AnySearch,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authHeader(),
          'CypherSearch': Crypter.encrypt(JSON.stringify(searchClientComptes))
        }
      };
      await axios(config)
        .then((response) => {

          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
            if (res.StatutCode == 200) {
              let datas = res.Result.Table;

              if (datas.length === 0) {
                SweetAlert.fire({ title: "This client don't have accounts", icon: "warning" })
              }
              else {
                const datat: DataCpt[] = [];
                let TotalDisp: number = 0;
                let TotalSoldV: number = 0;
                form.setFieldValue("TOTALSV", '');
                form.setFieldValue("TOTALD", '');

                datas.map((data: any, indice: number) => {
                  datat.push({
                    key: indice,
                    Etat: data.CDETAT,
                    TYCPT: data.IDPLAN,
                    NUMCPT: data.NUMCPT,
                    NOMCPT: data.NOMCPT,
                    AGCCPT: data.AGCCPT,
                    Solde: formatNumber(data.DISPON ? data.DISPON : ''),
                    SoldeV: formatNumber(data.SOLDEV ? data.SOLDEV : ''),
                    DATCRE: data.DATCRE ? (new Date(data.DATCRE.substring(0, 10))).toLocaleDateString("fr") : '',
                    DatMaj: data.DATMAJ ? (new Date(data.DATMAJ.substring(0, 10))).toLocaleDateString("fr") : '',
                  });

                  TotalDisp += data.DISPON;
                  TotalSoldV += data.SOLDEV;
                })

                setDataCpt(datat);
                form.setFieldValue("TOTALSV", formatNumber(TotalSoldV));
                form.setFieldValue("TOTALD", formatNumber(TotalDisp));
              }
             }
            // else {
            //    // SweetAlert.fire({ title: "Ce client ne posséde aucun compte", icon: "warning" })
            //  // form.setFieldValue("NUMCLI", "");
            // }
          }
        }).catch((error) => {
          SweetAlert.fire({ title: "Error", text: error.message, icon: 'error' });
            // HandlerActualiser();
        })
      //Financements, autorisations et statistiques liés au client (sans sélection de compte)
      await loadDetailClient();
      setLoading(false);
    }
  }


  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span>
          <UserOutlined />

          Comptes
        </span>
      ),
      children: (
        <>
          <div className='tabItem' >
            <div>
              <Box width={"85%"} position={"absolute"} className='border'>
                <Box fontStyle="inherit" className='border-left '>
                   <Box >
                      <Box className='bordure1' >
                        <SearchInput notRequired form={form}  Titre={"Recherche Client"} label={"Indice client"} name={"NUMCLI"} Parametre={searchClient} handleFunction={loadCompteClient} />
                      </Box>
                    <Box >

                       <Box className='bordure1' >
                         <Search size='middle' placeholder="Search Here" onChange={(e: any) => { SetSearchR(e.target.value.trim()); }} />
                         <Table size='small' showHeader bordered={true} pagination={false} rowSelection={{ ...rowSelection, selectedRowKeys, type: 'radio' }} scroll={{ y: 210, x: 1200 }} columns={columns} dataSource={DataCpt} />
                      </Box>

                      <Box>
                        <Box className='bordure1' display={"flex"}  fontStyle="inherit" >
                          <InputForm notRequired disabled width={10} label='Total Solde Veille' name='TOTALSV' defaultValue='' type='text' error='mobile' />
                          <InputForm notRequired disabled width={10} label='Total Disponible' name='TOTALD' defaultValue='' type='text' error='mobile' />
                        </Box>

                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>

            </div>
          </div>
        </>
      )
    }
    ,
    {
      key: '2',
      label: (
        <span>
          <UserOutlined />
          Historique
          {/* Compte */}
        </span>
      ),
      children: <Tab1 form={form} DataHistor={DataHisto} />,
    },
    {
      key: '3',
      label: (
        <span>
          <ContactsOutlined />
          Signataires
        </span>
      ),
      children: <Tab3 form={form} DataProCpt={DataProCpt} DataSingCpt={DataSingCpt} />,
    },
    {
      key: '4',
      label: (
        <span>
          <ContactsOutlined />
          Contact
        </span>
      ),
      children: <Tab4 form={form} />,
    },
    {
      key: '5',
      label: (
        <span>
          <ContactsOutlined />
           Financement
        </span>
      ),
      children: <Tab2  dataFindSalam={dataFinSalam}
          dataFindMourabaha={dataFinMourabaha}
          dataFindIjara={dataFinIjara}
         dataFindQard={dataFinQard} form={form} />,
    },
    {
      key: '6',
      label: (
        <span>
          <ContactsOutlined />
          Facilités
        </span>
      ),
      children: <Tab5 form={form} DataPeriodAuto={DataPeriodAuto} />,
    },
    {
      key: '7',
      label: (
        <span>
          <ContactsOutlined />
          Bloqués
        </span>
      ),
      children: <Tab7 form={form} DataMontantBloque={DataMontantBloque}></Tab7>,
    },
    {
      key: '8',
      label: (
        <span>
          <ContactsOutlined />
           Virements
          {/* Permenant */}
        </span>
      ),
      children: <Tab6 form={form} DataPeriodAuto={DataPeriodMVirement} />,
    },
    {
      key: '9',
      label: (
        <span>
          <BarChartOutlined />
          Statistiques
        </span>
      ),
      children: <Tab8 form={form} dataStats={dataStats} loading={loading} />,
    },
    {
      key: '10',
      label: (
        <span>
          <ContactsOutlined />
          SafeCare / BDC
        </span>
      ),
      children: <Tab9 form={form} dataStats={dataStats} />,
    },
  ];

  //En cas d'echec aux formulaire
  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];
    errorInfo.errorFields.map((error: any) => {
      errors.push(error.name + "");
    })
    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })

  };

  const onFinish = async (values: any) => {

    setDataHisto([]);

    if (index != -1) {
      let histocpt: HistoCpt = {
        datD: (new Date(values.datD)).toLocaleDateString("fr").replaceAll('/', '-'),
        DatF: (new Date(values.DatF)).toLocaleDateString("fr").replaceAll('/', '-'),
        Utilis: user.coduti,
        Agence: form.getFieldValue("AGCCPT"),
        Numcpt: DataCpt[index].NUMCPT,
        TypD: '0',
        Rgpt: '0',
        Idplan: DataCpt[index].TYCPT,
        anneeEncour: user.datjour.substring(0, 4),
        isConso: '0',
      };

      setLoading(true);
      //let group = profilsDistant.find(()=>)
      console.log('Received values of form: ', histocpt);

      let DataBody = Crypter.encrypt(JSON.stringify(histocpt));

      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetHistoriqueCpt,
        headers: {
          'CypherHistoCpt': DataBody,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        }
      };

      await axios.request(config)
        .then((response) => {
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;

            if (res.StatutCode == 200) {
              if (res.Result.length > 0) {

                const Datat: DataHistoCpt[] = [];
                let RePorSoldeI: number = 0;
                let RePorSolde: number = 0;
                let TotalDebit: number = 0;
                let TotalCrebit: number = 0;
                let NbrCrebit: number = 0;
                let Nbrdebit: number = 0;

                form.setFieldValue("ReportSold", '');
                form.setFieldValue("TotalDebit", '');
                form.setFieldValue("TotalCrebit", '');

                RePorSoldeI = res.Result[0].MONTANTCREDIT - res.Result[0].MONTANTDEBIT;
                RePorSolde = RePorSoldeI;


                res.Result.map((data: any, indice: number) => {

                  if (indice > 0) RePorSolde += data.MONTANTCREDIT - data.MONTANTDEBIT;
                  if (data.MONTANTDEBIT > 0) Nbrdebit++;
                  else NbrCrebit++;
                  Datat.push({
                    key: indice,
                    DATOPE: (new Date(data.DATOPE.substring(0, 10))).toLocaleDateString("fr"),
                    TIME: data.TIME,
                    DEDEVR: (new Date(data.DEDEVR.substring(0, 10))).toLocaleDateString("fr"),
                    REPECE: data.REPECE,
                    NUMRAP: data.NUMRAP,
                    LIBELL: data.LIBELL,
                    MONTANTDEBIT: formatNumber(data.MONTANTDEBIT),
                    MONTANTCREDIT: formatNumber(data.MONTANTCREDIT),
                    SOLDT: formatNumber(RePorSolde),
                    NBENEF: data.NBENEF,
                    UTISAI: data.UTISAI,
                    NLIGNE: data.NLIGNE
                  });

                  console.log(data);
                  //Incrémentation des Montants Totaux
                  TotalDebit += data.MONTANTDEBIT;
                  TotalCrebit += data.MONTANTCREDIT;
                })

                setDataHisto(Datat);

                SetImprimer(false);

                // form.setFieldValue("ReportSold", formatNumber(RePorSoldeI));
                form.setFieldValue("TotalDebit", formatNumber(TotalDebit));
                form.setFieldValue('TotalCrebit', formatNumber(TotalCrebit));
                form.setFieldValue("NbrCrebit", NbrCrebit);
                form.setFieldValue("Nbrdebit", Nbrdebit);
                form.setFieldValue("lastop", Datat[Datat.length - 1].DATOPE);
                localStorage.removeItem(Data.LocalVariable.tabHistCpt)

                localStorage.setItem(Data.LocalVariable.tabHistCpt, JSON.stringify({ "columns": column, "data": Datat, "form": form.getFieldsValue(), "Dispon": DataCpt[index].Solde, "P": "S" }))

                // SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" });
              }
              else {
                SweetAlert.fire({ title: "Oups", text: "Aucune Opération sur ce compte durant cette période", icon: "info" })
              }
            }
            else {
              SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" })
            }
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error)
          SweetAlert.fire({ title: "Error", text: error, icon: "error" })
        });
    }
    else SweetAlert.fire({ title: "Error", text: "impossible index non valide veuillez actualisé et reselectionner le compte", icon: "error" })
    setLoading(false);
  };

  const HandlerActualiser = () => {
    form.resetFields();
    SetNumcpt("");
    setDataCpt([]);
    setDataHisto([]);
    setSelectedRowKeys([]);
    initialiazeButton();
  }

  const HandlerLoadTab = async () => {
    setLoading(true);
    if (Numcpt !== "") {
      await consult(Numcpt);
    } else {
      form.setFieldsValue({ 'AGCCPT': '', 'lib_AGCCPT': '', 'datD': '', 'DatF': '', 'NUMCPT': '', 'lib_NUMCPT': '', 'CDETAT': '', 'lib_CDETAT': '', 'lastop': '', 'NIVCRE': '', 'NIVDEB': '', 'BlocSys': '', 'SOLVEI': '', 'AUTORI': '', 'SOLIN1': '', 'DISPON': '', 'TotalDebit': '', 'TotalCrebit': '' });
      setDataHisto([]);
      SetDataSingCpt([]);
      SetDataProCpt([]);
      let Nomcli = form.getFieldValue('lib_NUMCLI');
      if (typeof Nomcli == 'undefined') { }
      else if (Nomcli != '') SweetAlert.fire({ title: "Oups", text: "Veuillez Selectionner  un compte de " + Nomcli, icon: "info", confirmButtonColor: "green", cancelButtonColor: "darkred", })
    }
    setLoading(false);
  }


  return (
    <div>
      <div className='tab'>
        
        <Spin spinning={loading} size='large' style={{ color: 'green' }} >
          <Form disabled={ActiveForm} autoComplete="off" labelAlign='left' onFinish={onFinish} onFinishFailed={onFinishFailed} form={form} name="dynamic_form_complex" style={{ minWidth: 'auto', maxWidth: 'auto' }}>
            <div className='bG'>
              <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
              <Form.Item shouldUpdate className='bouttong'>
                <Space direction="vertical" style={{ width: '100%' }}>

                  <Button size='large' className='bt_add' disabled={Consulter} type="ghost" htmlType="submit" block  >
                    Consulter
                  </Button>
                  <Button size='large' className='bt_add' disabled={false} onClick={() => { HandlerActualiser() }} type="ghost" htmlType="button" block  >
                    Actualiser
                  </Button>
                  <Button size='large' disabled={Imprimer} onClick={() => {

                    // Validate required fields before calling the API
                    const numCli = form.getFieldValue("NUMCLI");
                    const numCpt = form.getFieldValue("NUMCPT");
                    const ville = Branch.agence?.VILLE;
                    const numReg = Branch.agence?.NUMREG;

                    if (!numCli || !numCpt || !ville || !numReg) {
                      SweetAlert.fire({
                        title: "Erreur de validation",
                        text: `Veuillez vérifier que les champs obligatoires sont remplis: ${!numCli ? 'NUMCLI ' : ''}${!numCpt ? 'NUMCPT ' : ''}${!ville ? 'VILLE ' : ''}${!numReg ? 'NUMREG ' : ''}`,
                        icon: "error"
                      });
                      return;
                    }

                    PrintHistCompteDirect(
                      user.coduti ?? '',
                      form.getFieldValue("AGCCPT") ?? '',
                      Branch.agence?.LIBELLE ?? '',
                      Branch.agence?.BANQUE ?? '',
                      Branch.agence?.TELEPH ?? '',
                      Branch.agence?.NUMREG ?? '',
                      Branch.agence?.LICENCE ?? '',
                      numCli, // NumCon should be client number
                      Branch.agence?.BPOSTE ?? '',
                      Branch.agence?.VILLE ?? '',
                      user.nomuti ?? '',
                      numCpt,
                      form.getFieldValue("datD") ?? '',
                      form.getFieldValue("DatF") ?? '',
                      "HISTORIQUE",
                      "PDF"
                    )
                  }} className='bt_add' type="ghost" htmlType="button" block  >
                    Aperçu
                  </Button>
                  <Button size='large' disabled={DataCpt.length === 0} onClick={() => {
                    const numCli = form.getFieldValue('NUMCLI');
                    if (!numCli) {
                      SweetAlert.fire({ title: "Erreur de validation", text: "Veuillez d'abord rechercher un client", icon: "error" });
                      return;
                    }
                    SweetAlert.fire({
                      title: "Exporter la fiche client",
                      text: "Choisissez le format d'export",
                      icon: "question",
                      showCancelButton: true,
                      showDenyButton: true,
                      confirmButtonText: "PDF",
                      denyButtonText: "Excel",
                      cancelButtonText: "Annuler",
                    }).then(async (result) => {
                      if (result.dismiss === SweetAlert.DismissReason.cancel) return;
                      const format = result.isConfirmed ? "PDF" : "XLSX";

                      // Le contexte agence peut être vide (rechargement, connexion MFA) :
                      // on recharge alors l'agence de l'utilisateur depuis l'API.
                      let ag = Branch.agence;
                      if (!ag) {
                        try {
                          const resp = await axios.get(Data.ApiUrl.allBranchs, {
                            headers: { Authorization: Data.SecretKey.ApiToken },
                          });
                          const res = JSON.parse(Crypter.decrypt(resp.data)).Value;
                          const found = (res?.Result || []).find((a: Agence) => String(a.CodeAgence) === String(user.codage));
                          if (found) {
                            ag = {
                              CODAGE: found.CodeAgence,
                              LIBELLE: found.Libelle,
                              VILLE: found.Ville,
                              TELEPH: found.Telephone,
                              BPOSTE: found.BPoste,
                              LICENCE: found.Licence,
                              BANQUE: found.Banque,
                              NUMCON: found.NumCon,
                              NUMREG: found.NumReg,
                            };
                          }
                        } catch (e) {
                          console.error('Impossible de charger les informations de l\'agence :', e);
                        }
                      }

                      printFicheClient(
                        ag?.CODAGE ?? user.codage ?? '',
                        ag?.LIBELLE ?? '',
                        ag?.BANQUE ?? '',
                        ag?.TELEPH ?? '',
                        ag?.NUMREG ?? '',
                        ag?.LICENCE ?? '',
                        ag?.NUMCON ?? '',
                        ag?.BPOSTE ?? '',
                        ag?.VILLE ?? '',
                        user.nomuti ?? '',
                        String(numCli),
                        format
                      );
                    });
                  }} className='bt_add' type="ghost" htmlType="button" block  >
                    Fiche client
                  </Button>

                  {/* <Button size='large' disabled={Imprimer} onClick={() => { navigate("/SituationClient/print/HistoriqueCpt"); }} className='bt_add' type="ghost" htmlType="button" block  >
                    Aperçu
                  </Button> */}
                </Space>
              </Form.Item>
            </div>
            <div className='clientP'>
              <div >
                <Tabs   style={{ overflowX: 'scroll', msOverflowY: 'scroll' }}  onChange={async (e) => { if (['2', '3', '4', '7', '8'].includes(e)) { HandlerLoadTab(); } }} size='small' type="card" defaultActiveKey="1" items={items} />
              </div>
              <div>
              </div>
            </div>
          </Form>
        </Spin>
      </div>
    </div>
  );
}
export default SituationCLient;
